import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TextViewComponent } from './text-view.component';
import { TextareaModalComponent } from './textarea-modal.component';
import { InputContainerComponent } from '../input-container/input-container.component';

@Component({
    standalone: true,
	imports: [CommonModule, FormsModule, InputContainerComponent],
	selector: 'wd-textarea',
	templateUrl: 'textarea-input.component.html',
	styleUrls: ['../styles/input.component.css', '../styles/view.component.css'],
})
export class TextareaInputComponent extends TextViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;

	/** Optional: CSS selector for parent container that enables modal editing */
	@Input() modalContainerSelector?: string;

	private modalService = inject(NgbModal);
	private elementRef = inject(ElementRef);

	constructor() {
		super();
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}

	isInModalContainer(): boolean {
		if (!this.modalContainerSelector) return false;
		let el: HTMLElement | null = this.elementRef.nativeElement;
		while (el) {
			if (el.matches && el.matches(this.modalContainerSelector)) {
				return true;
			}
			el = el.parentElement;
		}
		return false;
	}

	getDisplayName(): string {
		// Entferne Array-Index aus dem Namen, z.B. "Besonderheiten[0](10cm)" -> "Besonderheiten"
		return this.name.replace(/\[.*$/, '');
	}

	onInputClick($event: MouseEvent) {
		// Erst die normale onClick-Logik ausführen (für commenting etc.)
		this.onClick($event);

		// Modal nur öffnen wenn im konfigurierten Container
		if (this.aus.commenting) return;
		if (!this.isInModalContainer()) return;

		const modalRef = this.modalService.open(TextareaModalComponent, { size: 'lg' });
		modalRef.componentInstance.name = this.getDisplayName();
		modalRef.componentInstance.label = this.label;
		modalRef.componentInstance.value = this.model || '';
		modalRef.componentInstance.readonly = this.disabled();

		const blurInput = () => {
			const input = this.elementRef.nativeElement.querySelector('input');
			input?.blur();
		};

		modalRef.closed.subscribe((value: string) => {
			if (!this.disabled()) {
				this.model = value;
				this.vs.dirty.next(true);
				this.modelChange.emit(this.model);
			}
			blurInput();
		});

		modalRef.dismissed.subscribe(() => blurInput());
	}
}
